/* OrderJson.js */

'use strict';
// const _ = require('lodash');

let _;
// eslint-disable-next-line no-unused-vars
let log;

function OrderJson() {
}

OrderJson.initialize = function (lodash, logRef) {
  _ = lodash;
  log = logRef;
}

/**
 * Arranges properties of jsonToSort in the same order as jsonRef param. This helps in showing the differences between
 *  two jsons on UI.
 * @param jsonToSort - rearranges properties in the order of jsonRef
 * @param jsonRef - json to use as a reference for changing order of jsonToSort
 * @returns {*}
 */
OrderJson.order = function (jsonToSort, jsonRef) {
  if (_.isEmpty(jsonToSort) || _.isEmpty(jsonRef)) {
    return jsonToSort;
  } else if (_.isArray(jsonToSort) && _.isArray(jsonRef)) {
    return OrderJson.orderArray(jsonToSort, jsonRef);
  } else if (_.isPlainObject(jsonToSort) && _.isPlainObject(jsonRef)) {
    return OrderJson.orderObject(jsonToSort, jsonRef);
  } else {
    return jsonToSort;
  }
}

OrderJson.orderObject = function (jsonToSort, jsonRef) {
  let sortedJson = {};
  let jsonRefKeys = Object.keys(jsonRef);
  let jsonToSortKeys = Object.keys(jsonToSort);
  let commonKeys = _.intersection(jsonRefKeys, jsonToSortKeys);
  // console.log("common keys: " + JSON.stringify(commonKeys));
  let newKeysInJsonToSort;
  let newOrderOfProps = [...commonKeys];
  if (commonKeys.length !== jsonToSortKeys.length && !commonKeys.length !== 0) {
    newKeysInJsonToSort = _.difference(jsonToSortKeys, jsonRefKeys);
    newKeysInJsonToSort.forEach((newKey) => {
      let indexOfNewKey = jsonToSortKeys.indexOf(newKey);
      let keyIndexAfterAddedElement;
      for (let i = indexOfNewKey + 1; i < jsonToSortKeys.length && !keyIndexAfterAddedElement; i++) {
        // for(let i=indexOfNewKey-1; i >= 0 && !keyIndexAfterAddedElement; i--) {
        let keyAfterAddedElement = jsonToSortKeys[i];
        if (commonKeys.includes(keyAfterAddedElement)) {
          keyIndexAfterAddedElement = newOrderOfProps.indexOf(keyAfterAddedElement);
        }
      }
      // keyIndexAfterAddedElement = keyIndexAfterAddedElement ? keyIndexAfterAddedElement : 0;
      if (keyIndexAfterAddedElement) {
        newOrderOfProps.splice(keyIndexAfterAddedElement, 0, newKey);
      } else {
        newOrderOfProps.push(newKey);
      }
    });
  }
  // console.log('newOrderOfProps: ' + JSON.stringify(newOrderOfProps));
  newOrderOfProps.forEach((newKey) => {
    sortedJson[newKey] = jsonToSort[newKey];
    if (!_.isEmpty(jsonToSort[newKey]) && !_.isEmpty(jsonRef[newKey])) {
      // console.log("found nested prop at key " + newKey);
      sortedJson[newKey] = OrderJson.order(jsonToSort[newKey], jsonRef[newKey]);
    }
  });
  return sortedJson;
}

OrderJson.orderArray = function (jsonToSort, jsonRef) {
  let jsonRefLastIndex = jsonRef.length - 1;
  let newJsonSorted = [];
  jsonToSort.forEach((childElement, index) => {
    if (index <= jsonRefLastIndex) {
      let jsonRefElement = jsonRef[index];
      if (!_.isEmpty(childElement) && !_.isEmpty(jsonRefElement)) {
        let elementSorted = OrderJson.order(childElement, jsonRefElement);
        newJsonSorted.push(elementSorted);
      } else {
        newJsonSorted.push(childElement);
      }
    }
  });
  return newJsonSorted;
}

module.exports = OrderJson;
